import axios from 'axios';
import {_baseApiUrl} from '../redux/constants';
import authHeader from './auth-header';

const getAll = () => {
    return axios.get(_baseApiUrl + `/mp_communications`, { headers: authHeader() })
};

const filter = (filter) => {
    return axios.post(_baseApiUrl + `/mp_communications`, filter, { headers: authHeader() });
};

const get = (id) => {
    return axios.get(_baseApiUrl + `/mp_communications/${id}`, { headers: authHeader() });
};

const create = (data) => {
    return axios.post(_baseApiUrl + `/mp_communications`, data, { headers: authHeader() });
};

export default {
    getAll,
    get,
    filter,
    create,
};